import "./global"
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import  Vueaxios from 'vue-axios'
import 'lib-flexible/flexible'
import './utils/app.api.1.0.2'
import './utils/contraction/lrz.all.bundle'
import './assets/public..css'

import { isApp, judgeClient, keepTwoDecimalFull, getBase64,dateFormat } from './utils/judgeClient'
// axios.defaults.withCredentials=true;
// Vue.prototype.axios=axios;
// import "amfe-flexible"
//https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1575113926012&di=01094b6c5d17f2c9425d5e7826d2f0a3&imgtype=0&src=http%3A%2F%2Fb-ssl.duitang.com%2Fuploads%2Fitem%2F201505%2F23%2F20150523090306_fwtkR.thumb.400_0.gif





//卡号字体
import '../static/font/font-css.css'

import store from './store/index.js'
import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/dist/css/swiper.css'
import VeeValidate from 'vee-validate'
import helper from './store/helper'


import moment from 'moment'
Vue.prototype.$moment = moment


import VueLazyload from 'vue-lazyload'

import utils from './utils'; //获取url参数
Vue.prototype.$utils = utils; //注册全局方法
Vue.prototype.$judgeClient = judgeClient;
Vue.prototype.$isApp = isApp;
Vue.prototype.keepTwoDecimalFull = keepTwoDecimalFull;
Vue.prototype.dateFormat = dateFormat;
Vue.prototype.$getBase64 = getBase64;


import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
Vue.use(VueVideoPlayer)

Vue.use(VeeValidate);
global.storage = window.localStorage;
axios.defaults.withCredentials = true; //允许跨域

axios.interceptors.request.use(function(config) {
  // console.log(Object.prototype.toString.call(config.data));
  if (Object.prototype.toString.call(config.data) != '[object FormData]' && Object.prototype.toString.call(config.data)!= '[object URLSearchParams]') {
    if(config.method === 'post'){
      let data = config.data;
      // console.log(config,'config');
 
      config.data = {
        ...data, //拼接参数
        wxapp_id: localStorage.getItem("wxapp_id")||10001,
        // wxapp_id: 10060,
        token: localStorage.getItem("token") || sessionStorage.getItem("token") || "",
      }
    } 
  }
  if (!config.headers['Form-type']) {
    config.headers['Form-type'] = 'H5';
  }

  return config
})


axios.interceptors.request.use(function(config) {
  // 统一给 get + post 都加 wxapp_id 和 token
  const wxapp_id = localStorage.getItem("wxapp_id") || 10001;
  const token = localStorage.getItem("token") || sessionStorage.getItem("token") || "";

  // post 处理
  if (config.method === 'post') {
    if (Object.prototype.toString.call(config.data) != '[object FormData]' && 
        Object.prototype.toString.call(config.data)!= '[object URLSearchParams]') 
    {
      config.data = {
        ...config.data,
        wxapp_id: wxapp_id,
        token: token
      }
    }
  }

  // 👇 【修复关键】get 请求也自动加参数！！！
  if (config.method === 'get') {
    config.params = {
      ...config.params,
      wxapp_id: wxapp_id,
      token: token
    }
  }

  if (!config.headers['Form-type']) {
    config.headers['Form-type'] = 'H5';
  }

  return config
})
axios.interceptors.response.use(res => {
  console.log(res,'res.data.code');
  
  // 以下状态码跳转登录页面
  const redirectCodes = [306, 401, 402, 403, 404];
  if (redirectCodes.includes(res.data.code)) {
    window.location.href = "https://gzh.ensida.cn/#/phoneLogin";
    // window.location.href = "http://localhost:8081/#/phoneLogin";
  }
  return res
}, err => {
  return Promise.reject(err)
})

Vue.use(Vueaxios, axios);
Vue.use(VueAwesomeSwiper /* { default global options } */);


import {CheckboxGroup, Progress, Badge, Empty,Swipe, SwipeItem,PullRefresh,Tab,Tabs, ImagePreview,Cell,Icon,RadioGroup,Radio,List,Overlay,
  CellGroup,PasswordInput, NumberKeyboard,AddressEdit,Tabbar, TabbarItem,Lazyload,ActionSheet,
  Stepper,Sku,Popup,Loading,Dialog,Area,Toast,Uploader,NoticeBar,Button,Checkbox,TreeSelect,
  DatetimePicker,Steps,Step,DropdownMenu,DropdownItem,SwipeCell,Switch,Calendar,Picker,NavBar,Sticky,Search,Field,
  Collapse, CollapseItem
} from 'vant';
// import { Field } from 'vant';
// Vue.use(Field);

import { Image as VanImage } from 'vant';

Vue.use(VanImage);

import Router from "vue-router";
Vue.use(Swipe).use(SwipeItem).use(PullRefresh).use(Tab).use(Uploader).use(DatetimePicker).use(Checkbox).use(Toast)
   .use(Tabs).use(NoticeBar).use(ActionSheet).use(Icon),Vue.use(RadioGroup),Vue.use(Radio).use(Button).use(Lazyload)
   .use(ImagePreview).use(Cell).use(CellGroup).use(PasswordInput).use(NumberKeyboard).use(AddressEdit).use(Overlay)
   .use(Tabbar).use(TabbarItem).use(Stepper).use(Sku).use(Popup).use(Loading).use(Dialog).use(Area).use(TreeSelect)
   .use(Step).use(Steps).use(DropdownMenu).use(DropdownItem).use(SwipeCell).use(Switch)
   .use(List).use(Picker),Vue.use(Calendar).use(NavBar).use(Sticky).use(Search).use(Field)
   .use(Progress).use(Badge).use(Empty).use(CheckboxGroup).use(Collapse).use(CollapseItem)
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: 'http://hbimg.b0.upaiyun.com/f2952ed918ff1d6123c9033db99437c3ea722a8f1521-q1n8tE_fw236',
  // loading: 'http://img4q.duitang.com/uploads/item/201505/23/20150523090235_fJUxr.gif',
  loading: 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1575113926012&di=01094b6c5d17f2c9425d5e7826d2f0a3&imgtype=0&src=http%3A%2F%2Fb-ssl.duitang.com%2Fuploads%2Fitem%2F201505%2F23%2F20150523090306_fwtkR.thumb.400_0.gif',
  // attempt: 1
});


router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next();
  // var isRoute = JSON.parse(sessionStorage.getItem('userInfo')) || ''
  // if(to.meta.needrouter){
  //   if (isRoute.data.merchant_id > 0) {
  //   if (to.path == '/merUser') {
  //     console.log(666)
  //      next('/merUser');
  //   }
  // } else {
  //      console.log(777)
  //     next('/User');
  //   }
  //
  // }else {
  //   next();
  // }


});

// router.beforeEach((to,from,next)=>{
//   // var isRoute=JSON.parse(sessionStorage.getItem('userInfo'))||''
//   // // if(isRoute.data.merchant_id>0){
//   //    if(to.path == '/merUser'){
//   //    next();
//   // }
//   // // }
//   // // else{
//   // //   next('/User');
//   // // }
// });


//   router.beforeEach((to, from, next) => {
//      if(to.path!=="/Login"){
//        if(helper.getType(store.getters.getUser)==="Object"){
//          next()
//        }else if(to.path==="/register"){
//             next()
//        }else{
//          next("/Login")
//        }
//      }else {
//          next()
//        }
// })

// 小数点后保留两位
Vue.filter('keepTwoDecimalFull', keepTwoDecimalFull)

Vue.config.ignoredElements = ['wx-open-launch-weapp'];


new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js